"use client";

import { trackEvent } from "@/lib/analytics";

/**
 * Wraps content and tracks CTA clicks via event delegation.
 * Any descendant element with a `data-track` attribute will fire a
 * `cta_click` analytics event when clicked — no need for individual onClick handlers.
 */
export function CtaTracker({ children }: { children: React.ReactNode }) {
  return (
    <div
      onClick={(e) => {
        const target = (e.target as HTMLElement).closest<HTMLElement>(
          "[data-track]"
        );
        if (target) {
          trackEvent("cta_click", {
            label: target.getAttribute("data-track")!,
            page_path: window.location.pathname,
          });
        }
      }}
    >
      {children}
    </div>
  );
}
